import { render, staticRenderFns } from "./DiscountList.vue?vue&type=template&id=4513335c&scoped=true&"
import script from "./DiscountList.vue?vue&type=script&lang=js&"
export * from "./DiscountList.vue?vue&type=script&lang=js&"
import style0 from "./DiscountList.vue?vue&type=style&index=0&id=4513335c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4513335c",
  null
  
)

export default component.exports